'use client';

import { useQuery } from '@zg-rentals/react-query5';
import { useFeatureFlag } from '@/src/lib/feature-flags';

export function usePropertyMapKey(eligible: boolean) {
  const enabled = useFeatureFlag('property-maps') && eligible;
  const { data, isPending } = useQuery({
    queryKey: ['property-map-config'],
    queryFn: async ({ signal }): Promise<string> => {
      const response = await fetch('/api/property-map/config', { signal });
      if (!response.ok) throw new Error('Property map configuration unavailable');
      const config: { apiKey: string } = await response.json();
      return config.apiKey;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
  return { apiKey: enabled ? data ?? '' : '', isPending: enabled && isPending };
}
